/* eslint-disable no-use-before-define */
/* eslint-disable object-curly-newline */
import {
  format, getISOWeek, getISOWeekYear,
} from 'date-fns';
import getYear from 'date-fns/getYear';
import React from 'react';
import { countDecades, dayDays, decadeDays, getCountDay, getCountDecades, getCountMonth, getCountWeek, getCountYear, getHowManyDecade, monthDays, weekDays, yearDays } from './utils';

export const DAY = 'day';
export const WEEK = 'week';
export const MONTH = 'month';
export const YEAR = 'year';
export const DECADE = 'decade';

export const PERIOD_DICTIONARY = {
  [DAY]: 'День',
  [WEEK]: 'Неделя',
  [DECADE]: 'Декада',
  [MONTH]: 'Месяц',
  [YEAR]: 'Год',
};

export function usePagination(size, date) {
  const count = React.useMemo(() => {
    switch (size) {
      case DAY:
        return getCountDay(date);
      case WEEK:
        return getCountWeek(date);
      case MONTH:
        return getCountMonth(date);
      case YEAR:
        return getCountYear(date);
      case DECADE:
        return getCountDecades(date);

      default:
        return null;
    }
  }, [date, size]);

  const decadesList = React.useMemo(() => {
    if (size === DECADE) {
      const { decades } = countDecades(count, date);
      return decades;
    }
    return [];
  }, [size, count, date]);

  const getDate = React.useCallback((pageArg) => {
    const props = { count, pageArg, date };
    const start = new Date(date.startDate).setDate(new Date(date.startDate).getDate() + pageArg);
    const end = new Date(new Date(start).setHours(23)).setMinutes(59);

    if (size === DAY) {
      return dayDays(props);
    }
    if (size === WEEK) {
      return weekDays(props);
    }
    if (size === MONTH) {
      return monthDays(props);
    }
    if (size === YEAR) {
      return yearDays(props);
    }
    if (size === DECADE) {
      return decadeDays({ ...props, decadesList });
    }
    return { start, end };
  }, [count, date, decadesList, size]);

  const pageLabelBuilder = React.useCallback((e) => {
    let label = '';
    const { start, end } = getDate(count - e + 1);
    if (size === DAY) {
      label = format(new Date(start), 'dd.MM.yyyy');
      return label;
    }

    if (size === WEEK) {
      const week = getISOWeek(new Date(start), new Date(end));
      const year = getISOWeekYear(new Date(start), new Date(end));
      label = `${week}н. ${year}`;
      return label;
    }

    if (size === MONTH) {
      label = `${`${new Date(start).getMonth() + 1}`.padStart(2, '0')}.${getYear(new Date(start))}`;
      return label;
    }

    if (size === YEAR) {
      // console.log('start -- ', new Date(start))
      label = `${new Date(start).getFullYear()}`;
      return label;
    }
    if (size === DECADE) {
      label = `${getHowManyDecade(start.getDate(), 'start') + 1}д. ${(start.getMonth() + 1).toString().padStart(2, '0')}.${new Date(start).getFullYear()}`;
      return label;
    }
    return null;
  }, [count, getDate, size]);

  return { count, getDate, pageLabelBuilder };
}
